/**
 * Phase 10D: In-app notification banners (Section 17).
 * Types: info (blue), success (green), warning (orange), error (red).
 * Use for: check completed, better deals found, expiry warnings, failures.
 */

import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { Info as InfoIcon, CheckCircle, Warning, Error as ErrorIcon } from '@mui/icons-material';

const SEVERITY_MAP = {
  info: { severity: 'info', icon: InfoIcon },
  success: { severity: 'success', icon: CheckCircle },
  warning: { severity: 'warning', icon: Warning },
  error: { severity: 'error', icon: ErrorIcon },
};

export default function InAppBanner({
  type = 'info',
  title,
  message,
  onDismiss,
  dismissible = true,
  persistent = false,
  action,
  sx = {},
}) {
  const config = SEVERITY_MAP[type] || SEVERITY_MAP.info;
  const Icon = config.icon;
  const canClose = dismissible && !persistent && onDismiss;

  return (
    <Alert
      severity={config.severity}
      icon={<Icon />}
      onClose={canClose ? onDismiss : undefined}
      action={action}
      sx={{ mb: 2, ...sx }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  );
}
